import { render, staticRenderFns } from "./iso-sub-categories.vue?vue&type=template&id=322b41d4&scoped=true"
import script from "./iso-sub-categories.vue?vue&type=script&lang=js"
export * from "./iso-sub-categories.vue?vue&type=script&lang=js"
import style0 from "./iso-sub-categories.vue?vue&type=style&index=0&id=322b41d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b41d4",
  null
  
)

export default component.exports